import { queryClient } from '@/lib/query-client'
import { isQuoteDraftEditable } from './dtools-si'
import { QUERY_KEYS } from './query-keys'
import type { QuoteData } from './quotes'

// Bypass skips both checks: fix-missing-data writes run while the quote query
// itself has failed, so the cache can be empty.
export function assertQuoteEditable(bypassQuoteStateCheck: boolean) {
  if (bypassQuoteStateCheck) return

  const quote = queryClient.getQueryData<QuoteData>(QUERY_KEYS.quote())

  if (!quote) {
    throw new Error('Quote not found')
  }

  if (!isQuoteDraftEditable(quote)) {
    throw new Error(`Quote is not editable and all actions are disabled.`)
  }
}
